module.exports = __webpack_public_path__ + "static/media/Background.713bfc60.svg";